import "../../scss/quasar.scss";
import "@quasar/extras/material-icons/material-icons.css";

export default {
    config: {},
    plugins: {},
};
